import { render, staticRenderFns } from "./consultant.vue?vue&type=template&id=2e742525&scoped=true"
import script from "./consultant.vue?vue&type=script&lang=js"
export * from "./consultant.vue?vue&type=script&lang=js"
import style0 from "./consultant.vue?vue&type=style&index=0&id=2e742525&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e742525",
  null
  
)

export default component.exports